import { render, staticRenderFns } from "./mainCarousel.vue?vue&type=template&id=9694fba4&"
import script from "./mainCarousel.vue?vue&type=script&lang=js&"
export * from "./mainCarousel.vue?vue&type=script&lang=js&"
import style0 from "./mainCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports